import { render, staticRenderFns } from "./aside-movil.vue?vue&type=template&id=4c67e35a&"
import script from "./aside-movil.vue?vue&type=script&lang=js&"
export * from "./aside-movil.vue?vue&type=script&lang=js&"
import style0 from "./aside-movil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports